import { useMemo } from "react"
import type { GridSortModel } from "@mui/x-data-grid-pro"
import { useListNwssBiothreatSignalsNwssBiothreatSignalsGet } from "@phc/common/gen/threatAnalyticsGen"
import { usePrecomputedBiothreatSignals } from "./PrecomputedBiothreatSignalsContext"
import { ALL_DISEASES, ALL_GEO } from "./types"
import { useNwssDateParams } from "./usePrecomputedDateRangeParams"
import { mapSortModelToParams } from "./mapSortModelToParams"

const NWSS_SORT_FIELD_MAP: Record<string, string> = {
  publish_time: "latest_ongoing_date",
  title: "description",
  disease: "disease",
  resolved_location: "geo_name",
  cluster_count: "source_count",
}

export const usePrecomputedNwssSignals = ({
  page,
  sortModel,
  limit,
}: {
  page: number
  sortModel: GridSortModel
  /** Override the page size (e.g. fetch the full filtered set for the map). */
  limit?: number
}) => {
  const { nwssFilters, pageSize } = usePrecomputedBiothreatSignals()
  const effectiveLimit = limit ?? pageSize
  const dateParams = useNwssDateParams()

  const params = useMemo(() => {
    const sortParams = mapSortModelToParams(sortModel, NWSS_SORT_FIELD_MAP)

    return {
      disease:
        nwssFilters.disease !== ALL_DISEASES
          ? [nwssFilters.disease]
          : undefined,
      state: nwssFilters.state !== ALL_GEO ? nwssFilters.state : undefined,
      ...dateParams,
      ...sortParams,
      limit: effectiveLimit,
      offset: page * effectiveLimit,
    }
  }, [
    dateParams,
    nwssFilters.disease,
    nwssFilters.state,
    page,
    effectiveLimit,
    sortModel,
  ])

  return useListNwssBiothreatSignalsNwssBiothreatSignalsGet(params, {
    query: { placeholderData: previousData => previousData },
  })
}
